<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@CreatePricingHeader">
      E-Mail ändern
    </h5>

    <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="onCancelClick()"></button>
  </div>

  <div class="modal-body" style="padding: 10px;">
    <div class="mb-2">
      <label id="newpw" for="newEmail">Neue E-Mail-Adresse eingeben</label>
      <input type="text" id="newEmail" (keydown.enter)="onConfimClick()"  (input)="onInputChange($event)" #newEmailInput formControlName="newEmail" class="form-control" placeholder="Neue E-Mail-Adresse" />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" data-bs-dismiss="modal" i18n="@@CancelButton">Abbrechen</button>
    <button type="submit" [disabled]="isConfirmBtnDisabled" id="confirmBtn" class="btn btn-yellow" i18n="@@SaveButton" (click)="onConfimClick()">Speichern</button>
  </div>
</div>
